import React from 'react';
import { compose } from 'redux';
import AdminTemplate from 'components/templates/Admin';
import HeaderContainer from 'containers/HeaderContainer';
import LabsTitleContainer from 'containers/labs/LabsTitleContainer';
import SideBarContainer from 'containers/SideBarContainer';
import LabsContentContainer from 'containers/labs/LabsContentContainer';
import PageTitle from 'hoc/PageTitle';
import ProtectedRoute from 'hoc/ProtectedRoute';
import { SideBarObjects } from 'components/pages/config/DashboardSideBarObjects';
import PageView from 'hoc/PageView';
import { DASHBOARD_LABS_VIEW } from 'constants/capabilities';

const LabsIndexPage = props => (
    <AdminTemplate
        header={<HeaderContainer />}
        sidebar={<SideBarContainer navItems={SideBarObjects} />}
        title={<LabsTitleContainer />}>

        <LabsContentContainer {...props}/>
    </AdminTemplate>
);

export default compose(
    PageView({ page: 'Viewed Labs Landing Page', trackEntity: true }),
    PageTitle({ pageTitle: 'Labs Home', showGGBranding: true }),
    ProtectedRoute({ requiredCapabilities: [DASHBOARD_LABS_VIEW] }),
)(LabsIndexPage);



// WEBPACK FOOTER //
// ./src/components/pages/labs/LabsIndex.js